<template>
  <path
    d="M19 7.00018H5C3.9 7.00018 3 7.90018 3 9.00018V15.0002C3 16.1002 3.9 17.0002 5 17.0002H19C20.1 17.0002 21 16.1002 21 15.0002V9.00018C21 7.90018 20.1 7.00018 19 7.00018ZM18 15.0002H6C5.45 15.0002 5 14.5502 5 14.0002V10.0002C5 9.45018 5.45 9.00018 6 9.00018H18C18.55 9.00018 19 9.45018 19 10.0002V14.0002C19 14.5502 18.55 15.0002 18 15.0002Z"
  />
</template>
